import { Component, Input, Output, OnChanges, EventEmitter } from '@angular/core';
import { SimpleChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { Fichero } from '../../../core/modelos/fichero';
import { Activo } from '../../../core/modelos/activo';

@Component({
    selector: 'fuse-simple-list',
    templateUrl: './simple-list.component.html',
    styleUrls: ['./simple-list.component.scss']
})
export class SimpleListComponent {

    visibleItems: number = 4;
    estados: Array<Object> = [];

    @Output() callback: EventEmitter<Fichero> = new EventEmitter<Fichero>();
    @Output() viewAll: EventEmitter<Activo> = new EventEmitter<Activo>();

    @Input() title: string;
    @Input() items: Array<Fichero>;
    @Input() extended: boolean;

    constructor() {}

    ngOnChanges(changes: SimpleChanges) {
      if (changes.items && !changes.items.firstChange) {

        if (this.extended) {
          // Filtra por estados, borra undefined, y borra duplicados
          const _estados = changes.items.currentValue.map((x: any) => x.estado).filter(a => a).filter((elem, pos, arr) => arr.indexOf(elem) === pos);

          // Set empty
          this.estados = []
          for (let i of _estados) {
            this.estados.push({
              key: i,
              value: this.items.filter((x: any) => x.estado === i).length
            })
          }
        }
      }
    }

    filterBy(key: string) {
      this.items = this.items.filter((x: any) => x.estado === key)
    }

    doAction(fichero: Fichero) {
      this.callback.emit(fichero)
    }

    goToDocs() {
      this.viewAll.emit()
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/simple-list/simple-list.component.ts